export const productsList = [
  'Responsabilité civile professionnelle',
  'Multirisque professionnelle',
  'Multirisque immeuble',
  'Propriétaire non occupant-non exploitant',
  'Risque entreprise et industriel',
  'Responsabilité civile mandataire social',
  'Cyber',
  'Décennale',
  'Dommage-ouvrage',
  'Véhicules',
  'Flottes',
  'Marchandises transportées',
  'Mutuelle',
  'Mutuelle collective',
  'Prévoyance',
  'Retraite',
  'Habitation',
  'Automobile',
  'Moto',
  'Scooter',
  'Protection juridique',
  'Assurance emprunteur',
  'Bateau',
  'Avion',
  'Association'
];

export const formValues = [
  'name',
  'logo',
  'address',
  'cpltAddress',
  'cp',
  'city',
  'phone',
  'mail',
  'map'
];

export const contract = ['action'];

export const documents = [
  'insuranceCertificat',
  'timeline',
  'call',
  'invoice',
  'claimStatement'
];

export const payment = ['unpaid', 'paymentCall'];

export const sinister = ['preDeclaration', 'consulting', 'manage'];

export const compta = ['action'];

export const objectExp = {
  address: false,
  advAccess: false,
  city: false,
  clientAccess: false,
  compta: { action: 'hide' },
  contract: { action: 'hide' },
  cp: false,
  cpltAddress: false,
  documents: {
    call: 'hide',
    claimStatement: 'hide',
    insuranceCertificat: 'hide',
    invoice: 'hide',
    timeline: 'hide'
  },
  logo: false,
  mail: false,
  map: false,
  name: false,
  openHours: [],
  payment: {
    paymentCall: 'hide',
    unpaid: 'hide'
  },
  phone: false,
  products: [],
  showPolices: false,
  sinister: {
    consulting: 'hide',
    manage: 'hide',
    preDeclaration: 'hide'
  }
};

export const defaultConfig = {
  address: true,
  advAccess: true,
  city: true,
  clientAccess: true,
  compta: { action: 'allow' },
  contract: { action: 'allow' },
  cp: true,
  cpltAddress: true,
  documents: {
    call: 'allow',
    claimStatement: 'allow',
    insuranceCertificat: 'allow',
    invoice: 'allow',
    timeline: 'allow'
  },
  logo: true,
  mail: true,
  map: true,
  name: true,
  openHours: [],
  payment: {
    paymentCall: 'allow',
    unpaid: 'allow'
  },
  phone: true,
  products: [],
  showPolices: true,
  sinister: {
    consulting: 'allow',
    manage: 'allow',
    preDeclaration: 'allow'
  }
};
